import React, { Component } from 'react';
import { Collapse } from 'antd';
import { PAGE_DESC } from '../../config/constants';
import ResetForm from './ResetForm';
import { wrapStyle } from './style';
import './style.css';
import TwoFactor from './TwoFactor';
import { Wrapper } from './style';
import { getTabParams } from '../../common/utils';
const { Panel } = Collapse;

class Password extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isModal: false,
			activeKey: []
		}
	}

	componentDidMount () {
		const tabParams = getTabParams();
		if (tabParams && tabParams.isOpenTwoFA === 'true') {
			this.setState({ activeKey: ['2'] });
		}
	};

	handlePanelChange = (val) => {
		this.setState({ activeKey: val });
	};

	setModal = set => {
		this.setState({ isModal: set })
	}
	renderHeader = () => {
		const { otp_enabled } = this.props.user
		return (
			<div>
				<div>
					<span>
						{`Two-Factor Authentication`}
					</span>
					<span className="ex-tags">
						{
							otp_enabled ?
								<span className="active">Active</span> :
								<span className="Inactive">Inactive</span>

						}
					</span>
				</div>
				{
				!otp_enabled &&
				<div className='sub-head'>
					{`We highly recommend you set up two-factor authentication (2FA). Doing so will greatly increase the security of your funds.`}
				</div>
				}
			</div>
		)
	}
	render() {
		const { user, userAction } = this.props
		return (
			<Wrapper>
				<div>
					<h2>
						<b>{PAGE_DESC.reset.title}</b>
					</h2>
					<div style={wrapStyle}>
						<Collapse
							onChange={this.handlePanelChange}
							activeKey={this.state.activeKey}
						>
							<Panel header="Reset Password" key="1">
								<ResetForm />
							</Panel>
							<Panel className='two-factor' header={this.renderHeader()} key="2">
								<TwoFactor user={user} action={userAction} />
							</Panel>
						</Collapse>
					</div>
				</div>
			</Wrapper>
		);
	}
}

export default Password;
